import React from "react"
import {
  RiThumbDownFill,
  RiThumbDownLine,
  RiThumbUpFill,
  RiThumbUpLine,
} from "react-icons/ri"
import { useUserFeedbackCreateMutation } from "../../../api/backend/backend-api"
import Typography from "../../atoms/Typography"
import { FaqItem } from "./types"

interface Props {
  className?: string
  item: FaqItem
}

const FaqFeedback = ({ className, item }: Props) => {
  const [sendFeedback] = useUserFeedbackCreateMutation()
  const [selected, setSelected] = React.useState<boolean>()

  const handleFeedback = async (value: boolean) => {
    setSelected(value)
    await sendFeedback({
      variables: {
        input: {
          category: "faq",
          reference: item.slug ?? "",
          value: value === true ? "positive" : "negative",
        },
      },
    })
  }

  const thumbClasses = "cursor-pointer mx-2 text-subtitle2"

  return (
    <div className={`flex items-end ${className ?? ""}`}>
      <Typography variant="subtitle2" className="mr-6">
        Questa informazione ti è stata di aiuto?
      </Typography>
      <div className={thumbClasses} onClick={() => handleFeedback(true)}>
        {selected === true ? <RiThumbUpFill /> : <RiThumbUpLine />}
      </div>
      <div className={thumbClasses} onClick={() => handleFeedback(false)}>
        {selected === false ? <RiThumbDownFill /> : <RiThumbDownLine />}
      </div>
    </div>
  )
}

export default FaqFeedback
